import { defineComponent } from '../c-mp/fun/defineComponent'
import { json } from '../c-mp/fun/json'
import { andrisEmail } from '../fun/andrisEmail'
import { setPageTitle } from '../fun/setPageTitle'
import { appState } from '../model/appState'
import { _ } from '../model/ccc'

export const PageInvalidComp = defineComponent<{}>(
	'PageInvalidComp',
	(props, $) => {
		setPageTitle('Érvénytelen')

		return (
			<div class={_.ccc_page}>
				<h1>Ez az oldal érvénytelen: {JSON.stringify(appState.page)}</h1>
				<p>
					<a
						class={_.ccc_button__rounded}
						href={andrisEmail(
							json`Érvénytelen oldal: ${appState.page}`,
							'De ez az oldal érvénytelen. Úgy jutottam ide, hogy...',
						)}
					>
						Jelezd Andrisnak
					</a>
				</p>
			</div>
		)
	},
)
